/**
 * A simple hook to create toggleable state.
 *
 * Usage:
 * ```
 * function Component(props: {default: boolean}) {
 *   const [value, toggleValue] = useToggle(props.default);
 *   return (
 *     <div>
 *       <p>Value is "{value}".</p>
 *       <button onClick={toggleValue}>Switch!</button>
 *     </div>
 *   )
 * }
 */
import { useState, useCallback } from "react";

export default function useToggle(
  defaultValue: boolean,
): [boolean, () => void] {
  const [value, setValue] = useState(defaultValue);
  const toggler = useCallback(() => {
    setValue((prevVal) => !prevVal);
  }, []);
  return [value, toggler];
}
